import { Routes } from '@angular/router';
import { AuthGuard } from './services/auth.guard';
const ɵ0 = () => import("./tab1/tab1.module.ngfactory").then(m => m.Tab1PageModuleNgFactory), ɵ1 = () => import("./tab2/tab2.module.ngfactory").then(m => m.Tab2PageModuleNgFactory), ɵ2 = () => import("./tab3/tab3.module.ngfactory").then(m => m.Tab3PageModuleNgFactory), ɵ3 = () => import("./tab4/tab4.module.ngfactory").then(m => m.Tab4PageModuleNgFactory), ɵ4 = () => import("./scheduler/scheduler.module.ngfactory").then(m => m.SchedulerPageModuleNgFactory), ɵ5 = () => import("./settings/settings.module.ngfactory").then(m => m.SettingsPageModuleNgFactory), ɵ6 = () => import("./auth/auth.module.ngfactory").then(m => m.AuthModuleNgFactory);
const routes = [
    { path: '', redirectTo: 'tab1', pathMatch: 'full' },
    { path: 'tab1', loadChildren: ɵ0, canActivate: [AuthGuard] },
    { path: 'tab2', loadChildren: ɵ1, canActivate: [AuthGuard] },
    { path: 'tab3', loadChildren: ɵ2, canActivate: [AuthGuard] },
    { path: 'tab4', loadChildren: ɵ3 },
    // Auth is enforced inside Scheduler module to allow /scheduler/embedded without app login
    { path: 'scheduler', loadChildren: ɵ4 },
    { path: 'settings', loadChildren: ɵ5, canActivate: [AuthGuard] },
    { path: 'auth', loadChildren: ɵ6 },
];
export class AppRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6 };
